import React from "react";
import images from "../../../images";
import ImageSlider from "../SlideShowImage/ImageSlider";

import Timer from "../../../pages/Quest/DetailMultipleChoice/Timer";
import Status from "../Status/Status";

export const CardQuest = ({
  auth = true,
  thumbnails,
  percent,
  name,
  address,
  est_time,
  expire_time,
  token,
  onClick,
  consumerStatus,
  handleFavoriteQuest,
  isFavorited,
  businessId,
  xp,
  businessAvatar,
  slotAvailable,
  businessName,
  remainingTime,
}) => {
  const fileName = businessAvatar?.split("/").pop();

  return (
    <article
      onClick={onClick}
      className=" bg-white rounded-md border border-[#E9E6E4] border-solid  self-stretch cursor-pointer "
    >
      <div className="w-full relative rounded-md">
        <ImageSlider
          images={thumbnails}
          imageHeight={
            consumerStatus === "NOT_STARTED" ? "h-[125.667px]" : "h-[70.85px] "
          }
          applyImageOverlay={consumerStatus !== "NOT_STARTED"}
        />
        <div
          className={`flex absolute ${
            consumerStatus === "NOT_STARTED" ? "top-[68.27px]" : "top-[11.19px]"
          }  left-[12px] flex-col self-start text-xs font-bold text-center text-black rounded-none h-[70px] w-[70px] z-20`}
        >
          <figure className="flex shrink-0 self-stretch my-auto" />
          {businessAvatar ? (
            <div className="relative w-[70px] h-[70px] rounded-md overflow-hidden bg-white shadow-sm">
              <img
                src={`${process.env.REACT_APP_URL_IMAGE}/${businessAvatar}`}
                className="w-full h-full object-cover"
                alt={fileName || ""}
                style={{
                  imageRendering: "-webkit-optimize-contrast",
                  backfaceVisibility: "hidden",
                  transform: "translateZ(0)",
                  filter: "contrast(1.15) brightness(1.05) saturate(1.1)",
                  WebkitFontSmoothing: "antialiased",
                  MozOsxFontSmoothing: "grayscale",
                }}
                loading="lazy"
              />
            </div>
          ) : (
            <div className="w-[70px] h-[70px] rounded-full bg-gray-100 flex items-center justify-center">
              <img
                src={images.DefaultImageQuest}
                className="w-12 h-12 object-contain"
                alt={fileName || ""}
                style={{
                  imageRendering: "-webkit-optimize-contrast",
                  filter: "contrast(1.1)",
                }}
              />
            </div>
          )}
        </div>
        <div
          onClick={(e) => {
            e.stopPropagation(); // Prevent click from bubbling to parent
            handleFavoriteQuest();
          }}
          className={`flex absolute ${
            consumerStatus === "NOT_STARTED" ? "top-[12px]" : "top-[12px]"
          }  right-[12px] flex-col self-start text-xs font-bold text-center text-black rounded-none h-[24px] w-[24px] z-20 cursor-pointer`}
        >
          <img
            src={
              isFavorited === true
                ? images.Heart02ActiveIcon
                : images.Heart02Icon
            }
            alt="heart-icon"
          />
        </div>
      </div>
      <div className="flex flex-col p-2.5 gap-3   mt-4">
        {consumerStatus === "NOT_STARTED" ? (
          <>
            <div className="flex flex-col gap-[6px]">
              <div className="flex justify-between items-center w-full">
                <div>
                  <p className="text-xl font-medium">{businessName}</p>
                </div>
                <Status
                  status={
                    slotAvailable === 0 && consumerStatus === "NOT_STARTED"
                      ? "full"
                      : consumerStatus === "NOT_STARTED"
                      ? "eligible"
                      : consumerStatus === "COMPLETED"
                      ? "completed"
                      : consumerStatus === "REVIEWING"
                      ? "review"
                      : "eligible"
                  }
                />
              </div>
              <div className="flex gap-1.5 items-center w-full">
                <img
                  src={images.MapPinIcon}
                  alt="map-pin-icon"
                  className="h-[18px] w-[18px]"
                />
                <p className="text-base font-medium text-[#A0A0A0]">
                  {address ? address : ""}
                </p>
              </div>
              <div className="flex gap-1.5 items-center w-full text-base font-medium text-[#333333]">
                <p>{name}</p>
              </div>
            </div>
            <div className="flex justify-start items-center w-full gap-1.5">
              <div className="bg-[#ECEEFF] flex gap-[5px] items-center justify-center px-3 py-1.5 rounded-md text-[#253FF6] text-lg font-bold h-[30px]">
                <img
                  src={images.RallyCoinSmallBlueIcon}
                  alt="xp-icon"
                  className="h-[15px] w-[15px] "
                />
                <p>{token}</p>
              </div>
              <div className="bg-[#ECEEFF] flex gap-[5px] items-center justify-center px-3 py-1.5 rounded-md text-[#253FF6] text-lg font-bold h-[30px]">
                <img
                  src={images.RallyXPSmallBlueIcon}
                  alt="coin-icon"
                  className="h-[15px] w-[15px] "
                />
                <p>{xp}</p>
              </div>
            </div>
          </>
        ) : (
          <>
            {auth === true ? (
              <div className="flex flex-col gap-[6px]">
                <div className="flex justify-between items-center w-full">
                  <div>
                    <p className="text-xl font-medium">{businessName}</p>
                  </div>
                  <Status
                    status={
                      slotAvailable === 0 && consumerStatus === "NOT_STARTED"
                        ? "full"
                        : consumerStatus === "SAVE_QUEST"
                        ? "saved"
                        : consumerStatus === "PAUSED_QUEST"
                        ? "paused"
                        : consumerStatus === "REVIEWING"
                        ? "review"
                        : "paused"
                    }
                  />
                </div>
              </div>
            ) : (
              <>
                <div className="flex flex-col gap-[6px]">
                  <div className="flex justify-between items-center w-full">
                    <div>
                      <p className="text-xl font-medium">{businessName}</p>
                    </div>
                  </div>
                  <div className="flex gap-1.5 items-center w-full">
                    <img
                      src={images.MapPinIcon}
                      alt="map-pin-icon"
                      className="h-[18px] w-[18px]"
                    />
                    <p className="text-base font-medium text-[#A0A0A0]">
                      {address ? address : ""}
                    </p>
                  </div>
                  <div className="flex gap-1.5 items-center w-full text-base font-medium text-[#333333]">
                    <p>{name}</p>
                  </div>
                </div>
                <div className="flex justify-start items-center w-full gap-1.5">
                  <div className="bg-[#ECEEFF] flex gap-[5px] items-center justify-center px-3 py-1.5 rounded-md text-[#253FF6] text-lg font-bold h-[30px]">
                    <img
                      src={images.RallyCoinSmallBlueIcon}
                      alt="xp-icon"
                      className="h-[15px] w-[15px] "
                    />
                    <p>{token}</p>
                  </div>
                  <div className="bg-[#ECEEFF] flex gap-[5px] items-center justify-center px-3 py-1.5 rounded-md text-[#253FF6] text-lg font-bold h-[30px]">
                    <img
                      src={images.RallyXPSmallBlueIcon}
                      alt="coin-icon"
                      className="h-[15px] w-[15px] "
                    />
                    <p>{xp}</p>
                  </div>
                </div>
              </>
            )}
          </>
        )}
      </div>
      {remainingTime && <Timer time={remainingTime} isStatic={true} />}
    </article>
  );
};

export default CardQuest;
